import { PlaceholdersId, TFComponent } from '@types';
import { PersonalAccidentInsurancePlaceholder } from './personalAccidentInsurance';

export const personalAccidentInsurance: TFComponent = {
	component: PersonalAccidentInsurancePlaceholder,
	id: PlaceholdersId.personalAccidentInsurance,
	name: 'personalAccidentInsurance',
};
